<template>
  <form-builder-editor-field
    :item="item"
    :show-required="true"
    :show-hide-in-form="true"
    :show-hide-in-reports="true"
    :show-hide-in-preview="true"
    :show-share-with-participant="showShareWithParticipant"
    :show-is-shared="showIsShared"
    v-on="$listeners"
  />
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";

export default {
  components: {FormBuilderEditorField},

  props: {
    item: {
      type: Object,
      required: true
    },
    showShareWithParticipant: {
      type: Boolean,
      default: false,
    },
    showIsShared: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// FormBuilderEditorPhone.vue?b97247c2